import React from 'react';



export const Password = ({ height="52px", width="36px",padding="12px",style=''})=> (
<svg className="icon_person_outline" role="presentation" aria-label="" padding={padding} viewBox="0 0 26 22" version="1.1" xmlns="http://www.w3.org/2000/svg">
<g id="Symbols" stroke="none" strokeWidth="1" fill="rgb(97, 56, 245)" fillRule="evenodd">
<g>
<path d="M16.24,8.23V6.51A4.33,4.33,0,0,0,12,2.12,4.32,4.32,0,0,0,7.76,6.51V8.23A7,7,0,0,0,9.94,21.88h4.12A7,7,0,0,0,16.24,8.23Zm-7-1.72A2.82,2.82,0,0,1,12,3.63a2.82,2.82,0,0,1,2.75,2.88v1.4a5.07,5.07,0,0,0-.68,0H9.94a5.32,5.32,0,0,0-.69,0Zm4.8,13.86H9.94a5.5,5.5,0,0,1,0-11h4.12a5.5,5.5,0,0,1,0,11Zm-1.31-4.72v2.21h-1.5V15.65a1.5,1.5,0,1,1,1.5,0Z"/>
</g>
</g>
</svg>
);
